export const useTools = () => {
  const removeTags = (str) => {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();

    // Elimina las etiquetas HTML (incluyendo <a href>)
    str = str.replace(/(<([^>]+)>)/ig, '');

    // Elimina las entidades de escape específicas (p.ej., &lt;, &gt;, &amp;)
    str = str.replace(/&(lt|gt|amp);/g, '');

    return str;

  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const scrollToElement = (positionId) => {
    var target = document.querySelector(positionId); // Seleccionar el elemento con el ID deseado 
    var targetRect = target.getBoundingClientRect(); // Obtener la posición del elemento en la página 
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop; // Obtener la posición actual del scroll en la página 
    var targetOffsetTop = targetRect.top + scrollTop; // Calcular la posición del elemento respecto al top de la página 
    // Calcular la posición del scroll para que el elemento quede un poco más arriba 
    var scrollPosition = targetOffsetTop - 75; // Puedes ajustar el valor 100 a la cantidad de píxeles que desees 
    // Hacer el scroll a la posición calculada 
    window.scrollTo(0, scrollPosition);
  }

  const quitarCaracteresExtrañosId = (cadena) => {
    cadena = cadena.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[¿?¡!()\[\],.'"`~;:_+=<>{}\\\/$&*#@%]/g, '')
      .replace(/\s+/g, '_')
    return cadena;
  }

  //TODO Cambiar a  useLanguage
  const elegirIdioma = (language) => {
    switch (language) {
      case "es":
        return "es-ES";
      case "en":
        return "EN";
      case "ca":
        return "ca-ES";
      case "ga":
        return "gl-ES";
      case "eu":
        return "eu-ES";
      case "va":
        return "ca-ES-valencia"
      default:
        return "es-ES";
    }
  }

  const isValidDNI = (dni) => {
    var numero, letra, letras;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    dni = dni.toUpperCase();

    if (expresion_regular_dni.test(dni) === true) {
      numero = dni.substr(0, dni.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      letra = dni.substr(dni.length - 1, 1);
      numero = numero % 23;
      letras = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letras = letras.substring(numero, numero + 1);
      if (letras != letra) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  const isValidCIF = (cif) => {
    if (!cif || cif.length !== 9) {
      return false;
    }

    var letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    var digits = cif.substr(1, cif.length - 2);
    var letter = cif.substr(0, 1);
    var control = cif.substr(cif.length - 1);
    var sum = 0;
    var i;
    var digit;

    if (!letter.match(/[A-Z]/)) {
      return false;
    }

    for (i = 0; i < digits.length; ++i) {
      digit = parseInt(digits[i]);

      if (isNaN(digit)) {
        return false;
      }

      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit = parseInt(digit / 10) + (digit % 10);
        }

        sum += digit;
      } else {
        sum += digit;
      }
    }

    sum %= 10;
    if (sum !== 0) {
      digit = 10 - sum;
    } else {
      digit = sum;
    }

    if (letter.match(/[ABEH]/)) {
      return String(digit) === control;
    }
    if (letter.match(/[NPQRSW]/)) {
      return letters[digit] === control;
    }

    return String(digit) === control || letters[digit] === control;
  }

  const recortarTexto = (textoHTML, limite) => {
    if (textoHTML) {
      const palabras = textoHTML.split(" ");
      const etiquetas = [];
      let contador = 0;
      let resultado = "";

      palabras.forEach((palabra) => {
        if (contador >= limite) {
          return;
        }

        if (palabra.startsWith("<")) {
          etiquetas.push(palabra);
        } else if (palabra.endsWith(">")) {
          etiquetas.pop();
        }

        contador++;
        resultado += palabra + " ";
      });

      etiquetas.reverse().forEach((etiqueta) => {
        resultado += etiqueta + " ";
      });

      return resultado.trim();
    } else {
      return "";
    }


  }

  return { removeTags, scrollToTop, elegirIdioma, scrollToElement, isValidDNI, isValidCIF, recortarTexto, quitarCaracteresExtrañosId }

}
